import { Fulfillment } from "./fulfillment.types";

export const onCallFunctionsConst = [
  // system ones
  "registerInterest",
  "presignUpload",
  "presignFileUpload",
  "transferNewUploadedImages",
  "transferNewUploadedFiles",
  "deleteImages",
  "deleteFiles",
  "consumeInvitation",
  "createUserSegment",
  "createStripeAccount",
  "refreshOnboardingLink",
  // order ones
  "addItemToCartAndHydrate",
  "updateItemQuantityAndHydrate",
  "getIntent",
  "orderCompleteTransfer",
  "flagInteractionCall",
  "updateFulfillmentsBeforeShipping",
  "updateShipmentIsBeingReconfigured",
  "startRefund",
  "completeRefund",
  "completeReturn",
  "submitReview",
  //listing ones
  "filteredSearch",
  // digital information ones
  "saveDigitalInformation",
  // admin ones
  "deleteAllAccounts",
  "setUpTaxes",
  "tmpQueryAllOrders",
  "tempProcessWebhooks",
  "sendTestEmail",
  // shippo ones
  "getRatesForOrder",
  "getRatesForTemporaryParcelChanges",
  "getShippoAddressId",
  "addShippingRateToOrderItem",
  "getShippingRateInfo",
  "acceptShippingRate",
  "updateAddressAndShippoAddressId",
  "getShippingInformation",
] as const;

export type OnCallFunction = typeof onCallFunctionsConst[number];

export const onCallFunctions = Object.fromEntries(
  onCallFunctionsConst.map((val) => [val, val])
) as { [K in OnCallFunction]: K };


export interface UpdateFulfillmentsBeforeShippingVariables{
  orderId: string;
  fulfillments: Fulfillment[];
}